import { Menu, Segmented } from "antd";
import { getMenuItems } from "./menuService";
import { useEffect, useState } from "react";
import logo from '../assets/logo.png'
import rdt from '../assets/logos/logo-rdt_WHITE-extended.png'
import adbMenu from '../assets/logos/adbMenu.png'
import './menuApp.css'
import { useNavigate, useParams } from "react-router-dom";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { set } from "ol/transform";

export function MenuApp() {
    let { id, idSplit } = useParams();
    const [menuItems, setMenuItems] = useState([])
    const [menuKeys, setMenuKeys] = useState([])
    const [isCollapsed, setIsCollapsed] = useState(false)
    const [isRightView, setIsRightView] = useState(true)
    const navigate = useNavigate()

    useEffect(() => {
        if (menuItems.length > 0) {
            if (idSplit) {
                const menubuffer = [...menuItems]
                const idxh3 = menubuffer.findIndex(item => item.key === 'h3')
                menubuffer[idxh3]['disabled'] = true                                    //disable h3 if on splitview
                const idxdash = menubuffer.findIndex(item => item.key === 'dashboard')
                menubuffer[idxdash]['disabled'] = true                                  //disable dashboard if on splitview
                setMenuItems(menubuffer)
            }
            else {
                const menubuffer = [...menuItems]
                const idxh3 = menubuffer.findIndex(item => item.key === 'h3')
                menubuffer[idxh3]['disabled'] = false                                    //enable h3 if on splitview
                const idxdash = menubuffer.findIndex(item => item.key === 'dashboard')
                menubuffer[idxdash]['disabled'] = false                                  //enable dashboard if on splitview
                setMenuItems(menubuffer)
            }
        }
    }, [idSplit]);

    useEffect(() => {
        getMenuItems().then((response) => {
            const data = [
                {
                    key: "home",
                    label: "Home"
                },
                { type: 'divider' },
                ...response.data,
                { type: 'divider' },
                {
                    key: "h3",
                    label: "Risk analyzer"
                },
                {
                    key: "dashboard",
                    label: "Carbon footprint simulator"
                },
            ]

            setMenuItems(data)
        })
    }, []);

    const onClick = (e) => {
        if (e.key === 'home') {
            navigate('/')
            return
        }
        if (e.key === 'dashboard') {
            navigate('/dashboard')
            return
        }
        if (e.key === 'h3') {
            navigate('/h3')
            return
        }

        if (idSplit) {
            if (isRightView) {
                navigate(`/layer/${id}/${e.key}`)
            } else {
                navigate(`/layer/${e.key}/${idSplit}`)
            }
        } else {
            navigate(`/layer/${e.key}`)
        }
    }

    function onChangeView(value) {
        setIsRightView(value === 'Right')
    }

    const onSelect = (keys) => {

        if (keys.length === 2
            && keys[0].substring(0, 2) === 'c_'
            && keys[1].substring(0, 2) === 'c_'
        ) {
            keys.shift()
        } else if (keys.length === 3
            && keys[1].substring(0, 3) === 'sc_'
            && keys[2].substring(0, 2) === 'c_'
        ) {
            keys = [keys.pop()]
        } else if (keys.length === 3
            && keys[1].substring(0, 3) === 'sc_'
            && keys[2].substring(0, 3) === 'sc_'
        ) {
            keys.splice(1, 1)
        }

        setMenuKeys(keys)
    }

    return (
        <div className="sidebar">
            <div className="Header">
                <a href="https://www.adb.org/" target="_blank">     
                    <img src={adbMenu} alt="Asian Development Bank"
                        style={{
                            cursor: 'pointer',
                            width: 200,
                            marginTop: 20,
                            marginBottom: 20,
                        }} />
                </a>
                {isCollapsed
                    ?
                    <DownOutlined style={{ color: 'white', margin: '10px' }} onClick={() => setIsCollapsed(!isCollapsed)} />
                    :
                    <UpOutlined style={{ color: 'white', margin: '10px' }} onClick={() => setIsCollapsed(!isCollapsed)} />}
            </div>

            {isCollapsed
                ? <></>
                : <Menu
                    defaultSelectedKeys={[id]}
                    onOpenChange={onSelect}
                    openKeys={menuKeys}
                    onClick={onClick}
                    style={{
                        width: 300,
                    }}
                    mode="inline"
                    theme="dark"
                    items={menuItems}
                    inlineIndent={15} />
            }

            {idSplit && <Segmented
                className="menu-segmented"
                defaultValue="Right"
                options={["Left", "Right"]}
                size="small"
                onChange={onChangeView}
                block />}
        </div>
    )
}